import React from 'react';
// import CheckboxStyle from './styles';

const Checkbox = props  => (<input type="checkbox" {...props} />);

export default Checkbox;
